/**
 * The Logo Background API path.
 */
export const logoBackgroundAPIPath = "/logobackground";
